import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor(
    private httpClient: HttpClient
  ) {}

  getVersion(): Observable<string> {
    return this.httpClient.get('assets/version.txt', { responseType: 'text' });
  }
}
